import { createApp } from 'vue'
import Indirim from './Indirim.vue'
import './assets/global.css'

createApp(Indirim).mount('#indirim')
